import { AvatarPicture } from "components";


/**
 * AvatarRow component renders a horizontal list of avatar pictures with overlap.
 * If no items are provided, it shows a muted message indicating the absence of items.
 * @memberof module:components/avatars 
 * @param {object} props - Component props.
 * @param {Array<object>} [props.items=[]] - Array of user or station objects.
 * Each item can have:
 *   - stationId {string} (optional)
 *   - stationName {string} (optional)
 *   - firstName {string} (optional)
 *   - lastName {string} (optional)
 *   - emailAddress {string} (optional)
 * @param {string} props.type - Label name used when no items are present.
 *
 * @returns {JSX.Element} List of avatar pictures or a no-items message.
 */
const AvatarRow = ({ items = [], type }) => {
  if (!items.length) return <div className="text-muted small" style={{ fontStyle: "italic" }}>No {type}</div>;
  return items.map((item, index) => (
    <div key={item.stationId || item.emailAddress || index} style={{ marginLeft: index === 0 ? 0 : -12, zIndex: 12 - index }}>
      {item.stationId ? (
        <AvatarPicture width={28} height={28} stationId={item.stationId} stationName={item.stationName} />
      ) : (
        <AvatarPicture
          width={28}
          height={28}
          {...(item.firstName || item.lastName
            ? { first_name: item.firstName, last_name: item.lastName }
            : { email_address: item.emailAddress })}
        />
      )}
    </div>
  ));
};

export default AvatarRow;